import {
  NodeArticle,
  NodeBasicPage,
  NodeDetailPage,
  NodeEvent,
  NodeFaq,
  NodeHomepage,
  NodeLandingPage,
  NodeOverviewPage,
  NodePartner,
  NodeProject,
} from '../implementations';

const mappers = {
  article: NodeArticle,
  basic_page: NodeBasicPage,
  detail_page: NodeDetailPage,
  event: NodeEvent,
  faq: NodeFaq,
  homepage: NodeHomepage,
  landing_page: NodeLandingPage,
  overview_page: NodeOverviewPage,
  partner: NodePartner,
  project: NodeProject,
};

export default mappers;
